var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 7,
    stroke: "current",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 3L13 3L13 5H11L11 3Z",
    stroke: "current",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 11L21 13L20 13L20 11L21 11Z",
    stroke: "current",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 11L4 13L3 13L3 11L4 11Z",
    stroke: "whicurrentte",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6567 4.92886L19.0709 6.34307L18.1409 7.27316L16.7267 5.85895L17.6567 4.92886Z",
    stroke: "current",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.9541 16.6315L7.36831 18.0457L6.34301 19.071L4.9288 17.6568L5.9541 16.6315Z",
    stroke: "current",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11 19H13L13 21H11L11 19Z",
    stroke: "current",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.92886 6.34326L6.34307 4.92905L7.30865 5.89462L5.89444 7.30883L4.92886 6.34326Z",
    stroke: "current",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5714 17.9858L17.9857 16.5716L19.071 17.6569L17.6568 19.0712L16.5714 17.9858Z",
    stroke: "current",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingLogo);
export default __webpack_public_path__ + "static/media/setting_logo.298109755658e103c8fe9651bb9d27a2.svg";
export { ForwardRef as ReactComponent };